import React from 'react';

const EmptyState = ({ title = 'データがありません', description = '条件を変更するか、新規作成してください。' }) => (
  <div style={{ padding: '24px', textAlign: 'center', color: '#5f6368' }}>
    <div style={{ fontSize: '16px', marginBottom: '6px' }}>{title}</div>
    <div style={{ fontSize: '13px' }}>{description}</div>
  </div>
);

export default EmptyState;


